/** The ONE host for lib/inPageDialog.ts (mounted once in App next to the Toaster). */
import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { settleInPageDialog, subscribeInPageDialog, type Ask } from "@/lib/inPageDialog";


export function InPageDialogHost() {
  const [ask, setAsk] = useState<Ask | null>(null);
  const [value, setValue] = useState("");
  useEffect(() => subscribeInPageDialog((a) => {
    setAsk(a);
    setValue(a && a.kind === "prompt" ? a.initial ?? "" : "");
  }), []);

  return (
    <AlertDialog open={!!ask} onOpenChange={(o) => { if (!o) settleInPageDialog(false); }}>
      <AlertDialogContent className="bg-gray-900 border border-[#B8860B]/30 text-white max-w-[calc(100vw-32px)] sm:max-w-md rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">{ask?.title}</AlertDialogTitle>
          {ask?.body ? <AlertDialogDescription className="text-gray-300 whitespace-pre-line">{ask.body}</AlertDialogDescription> : null}
        </AlertDialogHeader>
        {ask?.kind === "prompt" && (
          <input
            autoFocus
            aria-label={ask.title}
            inputMode={ask.inputMode}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); settleInPageDialog(true, value); } }}
            className="w-full rounded-lg border border-gray-600 bg-gray-800 px-3 py-2 text-base text-white outline-none focus:border-[#B8860B]"
          />
        )}
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="border-gray-600 bg-transparent text-gray-200 hover:bg-gray-800">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); settleInPageDialog(true, value); }}
            className={ask?.kind === "confirm" && ask.destructive ? "bg-red-600 text-white hover:bg-red-700" : "bg-[#B8860B] text-black hover:bg-[#9A7209]"}
          >
            {ask?.confirmLabel ?? (ask?.kind === "prompt" ? "OK" : "Confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
